import React from 'react';

export default function UnavailableCamera() {
  return (
    <div style={{ display: 'flex', alignContent: 'center' }}>
      Camera is unavailable
    </div>
  );
}
